import type {
  ServiceGetByIdResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { PemetaanWilkerData } from './types'

const BASE_PATH = '/report/pemetaan-wilker'

const QUERY_KEY = (key?: string | Record<string, unknown>) =>
  ['report', 'pemetaan-wilker', key] as const

const getNasional = (): ServiceQueryOptionType<
  ServiceGetByIdResponse<PemetaanWilkerData>
> => ({
  queryKey: QUERY_KEY({ level: 'nasional' }),
  queryFn: async () => {
    try {
      const response =
        await api.get<ServiceGetByIdResponse<PemetaanWilkerData>>(BASE_PATH)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getProvinsi = (
  provinsiId: string
): ServiceQueryOptionType<ServiceGetByIdResponse<PemetaanWilkerData>> => ({
  queryKey: QUERY_KEY({ level: 'provinsi', provinsiId }),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetByIdResponse<PemetaanWilkerData>
      >(`${BASE_PATH}/${provinsiId}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  },
  enabled: !!provinsiId
})

const getKota = (
  provinsiId: string,
  kotaId: string
): ServiceQueryOptionType<ServiceGetByIdResponse<PemetaanWilkerData>> => ({
  queryKey: QUERY_KEY({ level: 'kota', provinsiId, kotaId }),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetByIdResponse<PemetaanWilkerData>
      >(`${BASE_PATH}/${provinsiId}/${kotaId}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  },
  enabled: !!provinsiId && !!kotaId
})

const clearCache = async (params?: {
  provinsiId?: string
  kotaId?: string
}): Promise<ServiceGetByIdResponse<unknown>> => {
  try {
    const { provinsiId, kotaId } = params ?? {}
    let path = `${BASE_PATH}/cache`

    if (provinsiId && kotaId) {
      path = `${BASE_PATH}/${provinsiId}/${kotaId}/cache`
    } else if (provinsiId) {
      path = `${BASE_PATH}/${provinsiId}/cache`
    }

    const response =
      await api.delete<ServiceGetByIdResponse<unknown>>(path)
    return response.data
  } catch (error) {
    throw handleAxiosError(error)
  }
}

export const pemetaanWilker = {
  queryKey: QUERY_KEY(undefined),
  getNasional,
  getProvinsi,
  getKota,
  clearCache
}
